module.exports = __webpack_public_path__ + "static/bg-5479d9b7f752e5b0ef0824c9a4e80e33.png";